/**
 * Table-of-forms functionality used on RM and FG edit pages (user#edit_inventory, user#edit_finished_goods)
 */

import { initCollapsibleTables } from "~/jose_modern/collapsed_table.js";
import { once } from "~/jose_modern/once";
import { initializeLotCodeTypeahead } from "../lot_code_typeahead";
import { NAVIGATION_CANCELLED_EVENT } from "~/jose_modern/warn_unsaved_trigger";
import { handlePaginationScrolling } from "../pagination_handler";
import { CHANGED_ACTUAL_CLASS } from "./common";
import * as editing from "./editing";
import * as tableControls from "./table_controls";

// =============================================================================
// INITIALIZATION & LIFECYCLE
// =============================================================================

export const initializeInventoryAdjustPage = (pageConfig) => {
  const { resource } = pageConfig;

  const searchParams = new URLSearchParams(window.location.search);
  const adjustmentType = searchParams.get("adjustment_type") || "add";

  const context = {
    ...pageConfig,
    adjustmentType,
    endpoints: {
      adjust: `/${resource}/adjust_all`,
      reset: `/${resource}/reset_all`,
    },
  };

  // This function contains the inits that have to be re-triggered on partial replace
  const initializeDynamicBindings = () => {
    document
      .querySelectorAll(`.${CHANGED_ACTUAL_CLASS}`)
      .forEach((el) => el.classList.remove(CHANGED_ACTUAL_CLASS));
    editing.updateFloatingWidget(false);

    editing.createChangeTracker(context);
    initializeLotCodeTypeahead();

    tableControls.initializeSortingControl();
    tableControls.initializeFilterToggle(context);

    if (context?.onInit) {
      context.onInit();
    }
  };

  const submitHandler = editing.createSubmitHandler(context);
  document.addEventListener("click", submitHandler);

  document.addEventListener(NAVIGATION_CANCELLED_EVENT, editing.onUnsavedChangesCancelled);

  document.addEventListener("partial:replace", (event) => {
    const partial = event?.partial;
    if (
      [
        "inventories/supplier_form",
        "inventories/transporter_form",
        "finished_goods/receiver_form",
      ].includes(partial)
    ) {
      return;
    }

    tableControls.handlePartialReplace();
    initializeDynamicBindings();
    handlePaginationScrolling();
  });

  editing.initializeFloatingWidgetForm();
  editing.initializeLotCodeButtons();
  editing.initializeResetByLots();
  editing.initializeLotCodesRequiredPrompt(context);
  tableControls.initializeUrlQueryParamHandling();
  tableControls.initializeTagClick();
  once(document.body, "collapsibles-init", () => initCollapsibleTables(document));

  initializeDynamicBindings();
};
